var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnalyzerTable',{attrs:{"headers":_vm.existingManualRatesTableHeaders,"get-table-data-action":"AnalyzerStore/getExistingManualRates","table-data-getter":"AnalyzerStore/existingManualRates"}})}
var staticRenderFns = []

export { render, staticRenderFns }